import React from 'react';
import { motion } from 'framer-motion';

export const LoadingBadge = () => {
  return (
    <motion.div
      animate={{ opacity: [0.5, 1, 0.5] }}
      transition={{ duration: 1.5, repeat: Infinity }}
      className="inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600"
    >
      <div className="w-3 h-3 mr-1 rounded-full bg-gray-400 animate-pulse"></div>
      Loading...
    </motion.div>
  );
};